import React from 'react';

function Checkbox({ obj, id, checked, onChange }) {
  return (
    <>
      <div className="checkbox-container">
        <input className="box" id={id} type="checkbox" checked={checked} onChange={onChange} />
        <label htmlFor={id}>{obj.opt_in_copy || obj.name}</label>
      </div>
    </>
  );
}

export default Checkbox;
